/* eslint-disable max-len */
import React, { useState, useRef } from 'react';
import { IoClose } from 'react-icons/io5';
import Calendar from 'react-calendar';

import '../../assets/style/calendar.css';
import { ReactComponent as CalendarSvg } from '../../assets/svg/calendar.svg';
import useClickOutsideBox from '../hooks/useClickOutsideBox';
import { formatSimpleDate } from '../../utilities/dateTime';
import clsx from 'clsx';

const today = new Date();
const CustomDatePicker = ({ onChange, value, className, selectRange=true, calendarInputClassName, calendarTitle="Date Range", containerClassName, label, labelClassName, maxDate=today, minDate=null }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const wrapperRef = useRef(null);

  useClickOutsideBox(wrapperRef, () => setShowCalendar(false));

  const handleChange = (val) => {
    onChange(val);
    setShowCalendar(!showCalendar);
  };

  return (
    <div className={clsx(`relative flex`, containerClassName)}>
      {
        label && <div className={clsx('font-semibold',labelClassName)}>{label}</div>
      }
      <div className={clsx(
        "border-1 rounded-md py-2 px-2 text-sm text-gray-700 border-alat-dimGrey hover:border-alat-dark leading-tight relative dark:text-white",
        className
      )}>
        {value ? (
          <>
            <div
              className="pr-4 text-gray-700 w-max dark:text-white"
              role="presentation"
              onClick={() => setShowCalendar(!showCalendar)}
            >
              {/* If it is a date range this div will display the date range else it would display the single date value */}

              {
                selectRange ? `${formatSimpleDate(value?.[0])} - ${formatSimpleDate(value?.[1])}` : formatSimpleDate(value)
              }
            </div>
            <IoClose
              onClick={() => onChange(null)}
              className="absolute cursor-pointer top-2.5 right-1 text-base hover:bg-alat-dark hover:text-white dark:bg-alat-nero dark:text-white rounded-full p-1"
            />
          </>
        ) : (
          <div
            className={clsx(
              "flex cursor-pointer text-alat-dimGrey pr-14 relative dark:text-white",
              !calendarInputClassName && "w-max",
              calendarInputClassName
            )}
            role="presentation"
            onClick={() => setShowCalendar(!showCalendar)}
          >
            <CalendarSvg
              className="absolute cursor-pointer top-0.5 right-1 text-base"
            />
            <div>{calendarTitle}</div>
          </div>
        )}
      </div>
      {showCalendar && (
        <div className="overlay">
          <div className="calendar" ref={wrapperRef}>
            <Calendar
              onChange={handleChange}
              className="calendar dark:bg-alat-nero"
              value={value}
              selectRange={selectRange}
              maxDate={maxDate}
              minDate={minDate}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDatePicker;
